import React from 'react';
import cx from 'classnames';
import CloseIcon from 'react-icons/lib/io/android-close';

import * as AppActions from '../../modules/App/AppState';

const MenuItem = props => {
  const isActive = props.id === props.activeItem;
  const MenuItemClasses = cx('ifdw-menu--item', {
    active: isActive
  });

  const onClick = () => {
    if (isActive) {
      props.dispatch(AppActions.resetGroupFilter());
      return false;
    }
    props.dispatch(AppActions.setDataSet(props.id));
  }

  return (
    <div onClick={onClick} className={MenuItemClasses}>
      {props.label}
      <span className="ifdw-menu--icon">{isActive ? <CloseIcon /> : null }</span>
    </div>
  );
};

export default MenuItem;



/** WEBPACK FOOTER **
 ** ./src/components/Menu/MenuItem.js
 **/